import { Routes, Route } from "react-router-dom";
import { ClientLayout } from "../layouts";
import { WebRouter, AdminRouter, StudentRouter } from "../router";
import { useAuth } from "../hooks";
import { Home, PrivacyPolicy, TermsOfService } from "../pages/web";
import { EventDetail } from "../components/Web";

export function RouterManager() {
  const { user } = useAuth();
  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  if (!user) {
    return (
      <Routes>
        <Route path="/*" element={<WebRouter />} />
      </Routes>
    );
  }

  const isStudent = ["66e2830fdeac1a8e3fc50d5d", 3].includes(user?.roleId);

  return (
    <Routes>
      <Route path="/" element={loadLayout(ClientLayout, Home)} />
      <Route
        path="/events/:slug"
        element={loadLayout(ClientLayout, EventDetail)}
      />
      <Route
        path="/privacy-policy"
        element={loadLayout(ClientLayout, PrivacyPolicy)}
      />
      <Route
        path="/terms-of-service"
        element={loadLayout(ClientLayout, TermsOfService)}
      />
      <Route
        path="/*"
        element={isStudent ? <StudentRouter /> : <AdminRouter />}
      />
    </Routes>
  );
}
